import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const UploadIcon = ({
  width = 16,
  height = 16,
  stroke = '#fff',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 25"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M21 15.5V19.5C21 20.0304 20.7893 20.5391 20.4142 20.9142C20.0391 21.2893 19.5304 21.5 19 21.5H5C4.46957 21.5 3.96086 21.2893 3.58579 20.9142C3.21071 20.5391 3 20.0304 3 19.5V15.5M17 8.5L12 3.5M12 3.5L7 8.5M12 3.5V15.5"
    />
  </svg>
);
